import { AppHeader } from "../AppHeader/AppHeader.jsx";
import { ViewportGuard } from "../ViewportGuard/ViewportGuard.jsx";

export function AppShell({
  activeYear = "",
  alert = null,
  canRotateViewportToFit = false,
  children = null,
  currentPage,
  minHeight,
  minWidth,
  onYearChange = null,
  shouldShowViewportGuard = false,
  showAltHints = false,
  showViewportDebugBadge = false,
  tabs = [],
  t = (key) => key,
  viewportSize,
  yearOptions = []
}) {
  return (
    <div class="app-shell">
      <AppHeader
        currentPage={currentPage}
        tabs={tabs}
        alert={alert}
        t={t}
        activeYear={activeYear}
        yearOptions={yearOptions}
        onYearChange={onYearChange}
        showAltHints={showAltHints}
      />
      <main class="app-main">
        {children}
      </main>
      {showViewportDebugBadge ? (
        <div class="viewport-debug-badge">
          {viewportSize.width} x {viewportSize.height}
        </div>
      ) : null}
      {shouldShowViewportGuard ? (
        <ViewportGuard
          width={viewportSize.width}
          height={viewportSize.height}
          minWidth={minWidth}
          minHeight={minHeight}
          canRotateToFit={canRotateViewportToFit}
          t={t}
        />
      ) : null}
    </div>
  );
}
